import { useQuery } from "@tanstack/react-query"
import { getAllFeedAndCommentClaimAdmin } from "../../../../service/feedAndCommentClaim";
import { TableColumnsType } from "antd";
import dayjs from "dayjs";
import { Link } from "react-router-dom";
import { DefaultOptionType } from "antd/es/select";

const useGetAllFeedAndCommentClaimAdmin = <T,>(responseQuery?: string) => {
    const query = useQuery({
        queryKey: ['getAllFeedAndCommentClaimAdmin'],
        queryFn: () => getAllFeedAndCommentClaimAdmin<T>(responseQuery),
        select: res => res.data.data.getAllFeedAndCommentClaimAdmin
    })

    return query;
}

const feedAndCommentClaimColumns: TableColumnsType<IFeedAndCommentClaimAdminResponse> = [
    {
        title: '신고ID',
        dataIndex: 'claimId',
        render: (q, record) => <>{(record.targetType === 'feed' ? '게시글' : '댓글') + '-' + q}</>
    },
    {
        title: '처리상태',
        dataIndex: 'status',
        render: q => q ? q === 'complete' ? '처리완료(노출유지)' : '숨김처리' : '미처리'
    },
    {
        title: '신고일시',
        dataIndex: 'claimDateTime',
        render: q => dayjs(q).format('YYYY.MM.DD HH:mm'),
        sorter: (a, b) => dayjs(b.claimDateTime).diff(dayjs(a.claimDateTime))
    },
    {
        title: '신고자 닉네임',
        dataIndex: 'claimNickName',
    },
    {
        title: '작성자 닉네임',
        dataIndex: 'creatorNickName'
    },
    {
        title: '내용 미리보기',
        dataIndex: 'content',
        render: (q, record) => <Link to={`/community/feed-and-comment-claim-manage/${record.claimId}`}>{q.length > 10 ? q.slice(0, 10) + '...' : q}</Link>
    },
    {
        title: '원본 게시글 ID',
        dataIndex: 'feedId',
        render: q => <Link to={`/community/feed-manage/${q}`}>{q}</Link>
    },
    {
        title: '유형',
        dataIndex: 'targetType',
        render: q => q === 'feed' ? '게시글' : '댓글'
    },
    {
        title: '신고 사유',
        dataIndex: 'category'
    },
    {
        title: '신고 횟수',
        dataIndex: 'totalClaimCnt'
    },
    {
        title: '최종처리 일시',
        dataIndex: 'hiddenLastUpdatedTime',
        render: q => q ? dayjs(q).format('YYYY.MM.DD') : '-',
        sorter: (a, b) => a.hiddenLastUpdatedTime ? b.hiddenLastUpdatedTime ? dayjs(b.hiddenLastUpdatedTime).diff(dayjs(a.hiddenLastUpdatedTime)) : 1 : 1
    },
    {
        title: '최종 관리자',
        dataIndex: 'hiddenMemberName',
        render: q => q ? q : '-'
    },
    {
        title: '신고 관리',
        render: (_, record) => <Link to={`/community/feed-and-comment-claim-manage/${record.claimId}?targetType=${record.targetType}`}>관리</Link>
    }

]

const filterFeedHiddenStatusOptions: DefaultOptionType[] = [
    {
        value: 'all',
        label: '전체',
    },
    {
        value: 'null',
        label: '미처리',
    },
    {
        value: 'complete',
        label: '처리완료(노출유지)',
    },
    {
        value: 'hidden',
        label: '숨김처리',
    }
]

const filterFeedHiddenSearchCategoryOptions: DefaultOptionType[] = [
    {
        value: 'claimNickName',
        label: '신고자 닉네임',
    },
    {
        value: 'creatorNickName',
        label: '‘작성자 닉네임',
    },
    {
        value: 'content',
        label: '‘내용’',
    },
    {
        value: 'targetId',
        label: '원본 게시글 ID',
    }
]

export { useGetAllFeedAndCommentClaimAdmin, feedAndCommentClaimColumns, filterFeedHiddenStatusOptions, filterFeedHiddenSearchCategoryOptions }